<script setup>
import Modal from '@/components/Shared/Modal.vue';
import FormInput from '@/components/Shared/Form/Input/Index.vue';
import { useForm } from '@inertiajs/vue3';
import FormButton from '@/components/Shared/Form/Button.vue';
import Swal from 'sweetalert2';
import { inject } from 'vue';

const trans = inject('trans');

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  ticket: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['close']);

const form = useForm({
  spent_minutes: null,
  is_billable: false,
  logged_at: null,
  description: null,
});

const submit = () => {
  form.post(route('partner-support.tickets.store.time-registrations', { ticket: props.ticket.id }), {
    preserveScroll: true,
    onSuccess: () => {
      form.reset();

      emit('close');

      Swal.fire({
        icon: 'success',
        title: trans('__JSON__.Success') + '!',
        text: trans('__JSON__.Added log time'),
      });
    },
  });
};
</script>

<template>
  <modal :show="show" closeable @close="$emit('close')">
    <template #title>
      <h2 class="text-90 font_bold text-xl uppercase">{{ trans('__JSON__.Log time registration') }}</h2>
    </template>

    <template #content>
      <form class="my-4 w-full" role="form" @submit.prevent="submit">
        <form-input
          id="spent-minutes"
          v-model="form.spent_minutes"
          :error="form.errors.spent_minutes"
          :label-text="trans('__JSON__.Spent Minutes')"
          :placeholder="trans('__JSON__.Spent Minutes')"
          container-class="row-span-2"
          type="text"
        />
        <form-input
          id="description"
          v-model="form.description"
          :error="form.errors.description"
          :label-text="trans('__JSON__.Description')"
          :placeholder="trans('__JSON__.Description')"
          container-class="row-span-2"
          type="textarea"
        />
        <form-input
          id="log-date"
          v-model="form.logged_at"
          :error="form.errors.logged_at"
          :help-text="trans('__JSON__.When empty it will use the current date time.')"
          :label-text="trans('__JSON__.Log Date')"
          :placeholder="trans('__JSON__.Log Date')"
          container-class="row-span-2"
          type="datetime"
        />
        <div>
          <form-input
            id="is-billable"
            v-model="form.is_billable"
            :error="form.errors.is_billable"
            :label-text="trans('__JSON__.Billable')"
            container-class="w-2/3 my-4"
            type="checkbox"
          />
        </div>
        <div class="flex justify-content-end">
          <form-button
            :value="trans('common.cancel')"
            button-class="button button_secondary"
            type="button"
            @click="$emit('close')"
          />
          <form-button :processing="form.processing" :value="trans('__JSON__.Submit')" />
        </div>
      </form>
    </template>
  </modal>
</template>
